import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_dark.png'
import _imports_1 from '@/assets/images/new/illustration.png'
import _imports_2 from '@/assets/images/step1.png'
import _imports_3 from '@/assets/images/step3.png'
import _imports_4 from '@/assets/images/icon-copy.png'
import _imports_5 from '../../assets/images/bg-gery.png'


_pushScopeId("data-v-318c70a7")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "ctx" }
const _hoisted_3 = { class: "brand" }
const _hoisted_4 = {
  key: 0,
  class: "logo"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  src: "/images/sunpay.png"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_0
}
const _hoisted_8 = { class: "name font-bold" }
const _hoisted_9 = { class: "lang" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "slogan animated fadeInLeft"
}
const _hoisted_13 = { class: "title font-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "illustration" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  draggable: "false"
}, null, -1)
const _hoisted_17 = { class: "desc" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "order" }
const _hoisted_20 = { class: "head" }
const _hoisted_21 = { class: "title font-bold" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_23 = { class: "body" }
const _hoisted_24 = { class: "container" }
const _hoisted_25 = { class: "project" }
const _hoisted_26 = {
  key: 0,
  class: "list"
}
const _hoisted_27 = {
  key: 0,
  class: "item active"
}
const _hoisted_28 = { class: "info" }
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "name" }
const _hoisted_33 = {
  key: 0,
  class: "item active"
}
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-318c70a7><div class=\"icon\" data-v-318c70a7><img src=\"/images/sunpay.png\" alt=\"Sun Pay\" data-v-318c70a7></div><div class=\"value\" data-v-318c70a7><div class=\"name\" data-v-318c70a7>Sun Pay</div></div></div>", 1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "item active"
}
const _hoisted_37 = /*#__PURE__*/_createStaticVNode("<div class=\"info\" data-v-318c70a7><div class=\"icon\" data-v-318c70a7><img src=\"/images/icon-logo.png\" alt=\"Klickl Pay\" data-v-318c70a7></div><div class=\"value\" data-v-318c70a7><div class=\"name\" data-v-318c70a7>Klickl Pay</div></div></div>", 1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "container" }
const _hoisted_40 = {
  key: 0,
  class: "project"
}
const _hoisted_41 = { class: "title" }
const _hoisted_42 = { class: "list" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "info" }
const _hoisted_45 = { class: "icon" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "name" }
const _hoisted_49 = {
  key: 1,
  class: "project"
}
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "list" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "info" }
const _hoisted_54 = { class: "icon" }
const _hoisted_55 = ["src", "alt"]
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "name" }
const _hoisted_58 = {
  key: 0,
  class: "desc"
}
const _hoisted_59 = { class: "extend" }
const _hoisted_60 = {
  key: 0,
  class: "footer"
}
const _hoisted_61 = { class: "total" }
const _hoisted_62 = {
  key: 0,
  class: "item"
}
const _hoisted_63 = { class: "value" }
const _hoisted_64 = { class: "item" }
const _hoisted_65 = { class: "number font-bold" }
const _hoisted_66 = { class: "action font-bold" }
const _hoisted_67 = { class: "pay" }
const _hoisted_68 = { class: "head" }
const _hoisted_69 = { class: "title font-bold" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_71 = { class: "desc" }
const _hoisted_72 = { class: "body" }
const _hoisted_73 = { class: "container" }
const _hoisted_74 = {
  key: 0,
  class: "form"
}
const _hoisted_75 = { class: "label required" }
const _hoisted_76 = { class: "value" }
const _hoisted_77 = { class: "footer" }
const _hoisted_78 = { class: "action font-bold" }
const _hoisted_79 = {
  key: 1,
  class: "status"
}
const _hoisted_80 = {
  key: 0,
  class: "loader"
}
const _hoisted_81 = { class: "icon" }
const _hoisted_82 = ["src", "alt"]
const _hoisted_83 = { class: "name" }
const _hoisted_84 = { class: "amount" }
const _hoisted_85 = { class: "infos" }
const _hoisted_86 = { class: "label" }
const _hoisted_87 = { class: "value" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_89 = [
  _hoisted_88
]
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "label" }
const _hoisted_92 = { class: "value" }
const _hoisted_93 = {
  key: 0,
  class: "channel"
}
const _hoisted_94 = ["src", "alt"]
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { class: "label" }
const _hoisted_97 = { class: "value" }
const _hoisted_98 = { key: 2 }
const _hoisted_99 = { class: "label" }
const _hoisted_100 = { class: "value" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { key: 3 }
const _hoisted_104 = { class: "value full" }
const _hoisted_105 = {
  key: 4,
  class: "line"
}
const _hoisted_106 = { key: 5 }
const _hoisted_107 = { class: "label" }
const _hoisted_108 = { class: "value" }
const _hoisted_109 = { class: "item" }
const _hoisted_110 = { class: "label" }
const _hoisted_111 = { class: "value" }
const _hoisted_112 = { class: "copyright" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("a", { href: "mailto:business@klicklpay.com" }, "business@klicklpay.com", -1)
const _hoisted_114 = {
  key: 0,
  class: "background"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "background"
}, null, -1)
const _hoisted_116 = [
  _hoisted_115
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popover = _resolveComponent("van-popover")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_KP_INPUT = _resolveComponent("KP_INPUT")!
  const _component_KP_SELECT = _resolveComponent("KP_SELECT")!
  const _component_VueQrcode = _resolveComponent("VueQrcode")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["klickl-pay-cashier", [_ctx.data.dev]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.CashChannelList?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.CashChannelList[0].businessCashierLogo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.CashChannelList[0].businessCashierLogo,
                      alt: _ctx.CashChannelList[0].businessCashierName
                    }, null, 8, _hoisted_5))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.data.dev == 'sunpaysandbox' || _ctx.data.dev == 'sunpayprod')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                        : (_openBlock(), _createElementBlock("img", _hoisted_7))
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("cashier.h1")), 1)
        ]),
        _createVNode(_component_van_popover, {
          show: _ctx.showPopover,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopover = $event)),
          actions: _ctx.data.Languages,
          theme: "dark",
          onSelect: _ctx.changeLang
        }, {
          reference: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("img", {
                src: `/images/${_ctx.locale}.png`,
                alt: _ctx.locale
              }, null, 8, _hoisted_10),
              _createTextVNode(_toDisplayString(_ctx.getLangName), 1)
            ])
          ]),
          _: 1
        }, 8, ["show", "actions", "onSelect"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_i18n_t, {
                keypath: "cashier.payout",
                scope: "global"
              }, {
                br: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_i18n_t, {
                  keypath: "cashier.tip1",
                  scope: "global"
                }, {
                  br: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["payment", { ordered: _ctx.data.FormData.orderStatus !== 0 }])
      }, [
        (_ctx.data.FormData.orderStatus == 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["infos", { nexts: _ctx.step > 1 }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.paytype")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.CashChannelList?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (
                        _ctx.CashChannelList[0].businessCashierLogo &&
                          _ctx.CashChannelList[0].businessCashierName
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("img", {
                                        src: _ctx.CashChannelList[0].businessCashierLogo,
                                        alt: _ctx.CashChannelList[0].businessCashierName
                                      }, null, 8, _hoisted_30)
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.CashChannelList[0].businessCashierName), 1)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (_ctx.data.dev === 'sunpaysandbox' || _ctx.data.dev === 'sunpayprod')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                                ], 64))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_39, [
                    (_ctx.CashChannelList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("cashier.payment")), 1),
                          _createElementVNode("div", _hoisted_42, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CashChannelList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: item.code == _ctx.data.FormData.channelCode }]),
                                key: item.code,
                                onClick: 
                        () => {
                          _ctx.data.FormData.channelCode = item.code;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("img", {
                                      src: item.icon,
                                      alt: item.code
                                    }, null, 8, _hoisted_46)
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(item.name), 1)
                                  ])
                                ])
                              ], 10, _hoisted_43))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.PaymentTypeList?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("cashier.paytype")), 1),
                          _createElementVNode("div", _hoisted_51, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PaymentTypeList, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["item", { active: _ctx.data.FormData.paymentType == item.supportedChannelType }]),
                                key: item.id,
                                onClick: 
                        () => {
                          _ctx.data.FormData.paymentType = item.supportedChannelType;
                          _ctx.data.FormData.transactionFee = item.transactionFee;
                        }
                      
                              }, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("img", {
                                      src: 
                              _ctx.data.InterfaceUI[item.supportedChannelType]?.icon ||
                                '~@/assets/images/icon-other.png'
                            ,
                                      alt: item.supportedChannelType
                                    }, null, 8, _hoisted_55)
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, _toDisplayString(item.supportedChannelType), 1),
                                    false
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_ctx.data.InterfaceUI[item.supportedChannelType]?.name ||
                                _ctx.$t("cashier.other")), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("cashier.fee")) + ": " + _toDisplayString(item.transactionFee), 1)
                              ], 10, _hoisted_52))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, false]
                  ]),
                  (_ctx.CashChannelList?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          false
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.data.FormData.transactionFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_64, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.total")), 1),
                            _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          (_ctx.data.FormData.cancelUrl)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "btn cancel",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                              }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: "btn next",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cashier.payinfo")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t("cashier.desc")), 1)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    (!_ctx.result)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.dynamicsFiledList.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dynamicsFiledList, (field, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "item full",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.resverText(field?.field_name)), 1),
                                    _createElementVNode("div", _hoisted_76, [
                                      (field.type == 'text')
                                        ? (_openBlock(), _createBlock(_component_KP_INPUT, {
                                            key: 0,
                                            modelValue: _ctx.data.FormData[field.field_name],
                                            "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                            type: 'text',
                                            expand: field?.expand,
                                            placeholder: field?.field_name
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "expand", "placeholder"]))
                                        : _createCommentVNode("", true),
                                      (field.type == 'select')
                                        ? (_openBlock(), _createBlock(_component_KP_SELECT, {
                                            key: 1,
                                            modelValue: _ctx.data.FormData[field.field_name],
                                            "onUpdate:modelValue": ($event: any) => (_ctx.data.FormData[field.field_name] = $event),
                                            "field-name": field.field_name,
                                            index: index,
                                            list: field.value,
                                            onChange: _ctx.onSelectChange
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "field-name", "index", "list", "onChange"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn cancel",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nextStep(false)))
                          }, _toDisplayString(_ctx.$t("cashier.back")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.result && _ctx.data.FormData.cancelUrl)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn cancel",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paymentUrl(_ctx.data.FormData.cancelUrl, 'CANCEL')))
                          }, _toDisplayString(_ctx.$t("cashier.cancel")), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.result)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(["btn next", { disabled: _ctx.isDisableConfirm }]),
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextStep(true)))
                          }, _toDisplayString(_ctx.step == _ctx.steps ? _ctx.$t("cashier.pay") : _ctx.$t("cashier.next")), 3))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        ([1, 2, 3, 4, 5, 6, 7, 8].includes(_ctx.data.FormData.orderStatus))
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
              ([0, 1, 2, 3, 4].includes(_ctx.data.FormData.orderStatus))
                ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("img", {
                  src: `/images/status/${_ctx.CashPayOutOrderStatus[_ctx.data.FormData.orderStatus]}.png`,
                  alt: _ctx.CashPayOutOrderStatus[_ctx.data.FormData.orderStatus]
                }, null, 8, _hoisted_82)
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createTextVNode(_toDisplayString(_ctx.$t(`cashier.PayoutStatus[${_ctx.data.FormData.orderStatus}]`)) + " ", 1),
                _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.data.FormData.currency) + " " + _toDisplayString(_ctx.data.FormData.amount?.toFixed(2)), 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t("cashier.orderNo")), 1),
                    _createElementVNode("div", _hoisted_87, [
                      _createTextVNode(_toDisplayString(_ctx.data.FormData.outOrderNo) + " ", 1),
                      _createElementVNode("span", {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copy(_ctx.data.FormData.outOrderNo)))
                      }, _hoisted_89)
                    ])
                  ]),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.$t("cashier.channel")), 1),
                        _createElementVNode("div", _hoisted_92, [
                          (_ctx.data.FormData.channelIcon)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                _createElementVNode("img", {
                                  src: _ctx.data.FormData.channelIcon,
                                  alt: _ctx.data.FormData.channelName
                                }, null, 8, _hoisted_94)
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.data.FormData.channelName || "--"), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.accountType || _ctx.data.FormData.paymentType)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.$t("cashier.paymentType")), 1),
                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.data.FormData.accountType || _ctx.data.FormData.paymentType), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_98, [
                        _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.$t("cashier.paymentCode")), 1),
                        _createElementVNode("div", _hoisted_100, [
                          _createTextVNode(_toDisplayString(_ctx.data.FormData.paymentCode) + " ", 1),
                          _createElementVNode("span", {
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copy(_ctx.data.FormData.paymentCode)))
                          }, _hoisted_102)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.data.FormData.qrCode || _ctx.data.FormData.paymentCode)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          _createVNode(_component_VueQrcode, {
                            value: 
                        _ctx.data.FormData.accountType == 'QRIS'
                          ? _ctx.data.FormData.qrCode
                          : _ctx.data.FormData.paymentCode
                      ,
                            tag: "img",
                            options: {
                        width: 140,
                        margin: 0
                      }
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_105))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("li", _hoisted_106, [
                        _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.$t("cashier.fee")), 1),
                        _createElementVNode("div", _hoisted_108, _toDisplayString(_ctx.data.FormData.serviceFee) + " " + _toDisplayString(_ctx.data.FormData.currency), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_109, [
                    _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.$t("cashier.orderTime")), 1),
                    _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.FormatDateZone(_ctx.data.FormData.creationAt) || "--"), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_112, [
      (
          _ctx.CashChannelList?.length &&
            !_ctx.CashChannelList[0].businessCashierName &&
            _ctx.data.dev !== 'sunpaysandbox' &&
            _ctx.data.dev !== 'sunpayprod'
        )
        ? (_openBlock(), _createBlock(_component_i18n_t, {
            key: 0,
            keypath: "cashier.copyright",
            scope: "global"
          }, {
            mail: _withCtx(() => [
              _hoisted_113
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.dev !== 'sunpaysandbox' && _ctx.data.dev !== 'sunpayprod')
      ? (_openBlock(), _createElementBlock("div", _hoisted_114, _hoisted_116))
      : _createCommentVNode("", true)
  ], 2))
}